/**
 * Role definitions for route access. Used by config/routes.js and PrivateRoute.
 */
export const ROLES = {
  adminOnly: ['admin'],
  quality: ['admin', 'quality'],
  planners: ['admin', 'planner'],
  purchasing: ['admin', 'aankoop'],
  general: ['admin', 'quality', 'planner', 'aankoop', 'ingangscontrole', 'user'],
  dashboard: ['admin', 'quality', 'planner', 'aankoop', 'ingangscontrole', 'user'],
  operator: ['admin', 'ingangscontrole', 'user'],
};
